import type { ReactElement, ReactNode } from "react";
import styles from "./Badge.module.css";

export type BadgeTone =
  | "neutral"
  | "success"
  | "warning"
  | "danger"
  | "info"
  | "brand";

export type BadgeShape = "square" | "pill";

export interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  shape?: BadgeShape;
}

export function Badge({
  children,
  tone = "neutral",
  shape = "square",
}: BadgeProps): ReactElement {
  return (
    <span className={`${styles.badge} ${styles[tone]} ${styles[shape]}`}>
      {children}
    </span>
  );
}
